export enum NativeDataType {
  title = 'title',
  body = 'body',
  sponsoredBy = 'sponsoredBy',
  icon = 'icon',
  image = 'image',
  clickUrl = 'clickUrl',
  cta = 'cta',
  video = 'video'
}
